module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (26).cb9e5169.jpg";